module.exports = __webpack_public_path__ + "img/ic-triangle-dn.53cba3d9.svg";